import { apiFetch } from '../../services/http';

export type Score = {
  alias: string;
  values: Record<string, number>;
};

export async function recordEvent(alias: string, metric: string, value = 1): Promise<void> {
  if (!alias || !metric) return;
  try {
    await apiFetch(`/api/ranking/events`, {
      method: 'POST',
      body: JSON.stringify({ alias, metric, value }),
    });
  } catch (err) {
    // swallow errors in prototype
    console.warn('ranking record', err);
  }
}

export async function fetchTopScores(metric: string, limit = 10): Promise<Score[]> {
  if (!metric) return [];
  return apiFetch<Score[]>(`/api/ranking/top?metric=${encodeURIComponent(metric)}&limit=${limit}`);
}

export async function fetchUserScore(alias: string): Promise<Score> {
  if (!alias) return { alias: '', values: {} };

  // Fetch scores for all metrics and aggregate
  const metrics = ['posts', 'replies', 'helpful', 'listings', 'bookings', 'reputation'];
  const values: Record<string, number> = {};

  await Promise.all(
    metrics.map(async (metric) => {
      try {
        const scores = await apiFetch<Score[]>(`/api/ranking/top?metric=${encodeURIComponent(metric)}&limit=1000`);
        const userScore = scores.find(s => s.alias === alias);
        if (userScore && userScore.values[metric]) {
          values[metric] = userScore.values[metric];
        }
      } catch (err) {
        console.warn(`Failed to fetch ${metric} score:`, err);
      }
    })
  );

  return { alias, values };
}
